import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/police.png")